import { Component, OnInit, EventEmitter, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { GenericValue } from '../../../core/model/generic-value';
import { HisGenericValueService } from '../../../core/service/base/his-generic-value.service';

// import * as assert from 'assert';
import { map, tap } from 'rxjs/operators';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext" [showLabelTop]="options.showLabelTop">
            <p-autoComplete #content
                [hisDdKey]="options.ddKey"
                [formControl]="formControl"
                [suggestions]="filteredBooleanTypes"
                (completeMethod)="filterBooleanTypes($event)"
                [dropdown]="true"
                [forceSelection]="true"
                field="text">
            </p-autoComplete>
        </his-plam>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class YesNoSelectComponent extends HisDynamicFieldBase<string> implements OnInit {
    private genericValueService = inject(HisGenericValueService);

    @Output() valueChangeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    options: HisDynamicFieldConfig;

    // {id:0, text:'nein'}, {id:1, text:'ja'}
    private booleanTypes: GenericValue[];
    public filteredBooleanTypes: any[] = [];

    // the selected value as a GenericValue
    selectedGenericValue: GenericValue;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }

    ngOnInit() {
        this.booleanTypes = this.genericValueService.getBooleanTypes();
        console.log( 'yesno value =', this.value );
        this.selectedGenericValue = this.getGenericValue( this.value );
        console.log( 'yesno selectedGenericValue =', this.selectedGenericValue );
        super.initFormControl( this.selectedGenericValue );
        this.formControl.valueChanges.pipe(
            map( value => this.getStringValue( value ) ),
            tap( stringVal => this.setAndEmitNewStringValue( stringVal ) )
        ).subscribe();
    }

    setAndEmitNewStringValue( value: string ): void {
        this.value = value;
        this.valueChangeEvent.emit( value === null ? null : value === '1' );
    }

    private getGenericValue( value: string ): GenericValue {
        if ( value ) {
            //assert.ok( value === '0' || value === '1' );
            // TODO falls equivalent, auskommentiertes assert und Import löschen
            if (value === '0' || value === '1') {
                return this.booleanTypes.find( type => type.id.toString() === value );
            } else {
                throw new Error( 'value ' + value + ' must be 0 or 1!' );
            }
        } else {
            return null;
        }
    }

    /** completeMethod implementation boolean types */
    public filterBooleanTypes( event: { query: string } ) {
        this.filteredBooleanTypes = [];
        for ( let booleanType of this.booleanTypes ) {
            if ( booleanType.text.toLowerCase().includes( event.query.toLowerCase() ) ) {
                this.filteredBooleanTypes.push( booleanType );
            }
        }
    }

    getStringValue( genericValue: GenericValue ): string {
        return genericValue ? genericValue.id.toString() : null;
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        let matchingConfig = this.searchFieldConfig( entireFormConfig );
        if ( matchingConfig !== null && matchingConfig.defaultValue ) {
            console.log( '--> updateConfiguration matchingConfig.defaultValue: ', matchingConfig.defaultValue );
            this.formControl.setValue( this.getGenericValue( matchingConfig.defaultValue ), { emitEvent: false } );
        }
    }

    getControlValue(): any {
        return this.value;
    }
}
